import React, { useContext } from 'react';
import BookerContext from '../../context/bookerContext';
import { useValidatedInput } from '../../hooks/useValidatedInput';

const DownloadCurbApp = () => {
  const context = useContext(BookerContext);
  const {
    state: { downloadCurbAppUrl },
  } = context;

  const [setIsValid] = useValidatedInput('btn-view', downloadCurbAppUrl.length);

  if (!downloadCurbAppUrl) return <></>;

  return <div className="download-curb-app" />;
};

export default DownloadCurbApp;
